import React from 'react';
import PropTypes from 'prop-types';
import { at } from 'lodash';
import { useField, useFormikContext } from 'formik';
import {
  Autocomplete,
  FormHelperText,
  TextField
} from '@mui/material';
import { bool, boolean } from 'yup';


function AutocompleteMultiple(props:any) {

  const { label, options, onChange, element,  ...rest } = props;
  const formikProps = useFormikContext()
 
  const [field, meta,  isdisabled] = useField(props);

 

  const { value: selectedValue,  } = field;
  const [touched, error ] = at(meta, 'touched', 'error');
  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    
    if (touched && error) {
        return error;
    }
  }

  
  return (

    <Autocomplete
        multiple
        options={options}
        getOptionLabel={(option:any) => option.label}
        loading={true}
        loadingText={'Cargando...'}
        onChange={ (e,v) => formikProps.setFieldValue(field.name, v) } 
        value={selectedValue ? selectedValue : ''}
        renderOption={(props, option:any) => {
          return (
            <li {...props} key={option.value}>
              {option.label}
            </li>
          );
        }}
        renderInput={(params) => <TextField 
                                    key={params.id}
                                    helperText={_renderHelperText()} 
                                  {...params} 
                                  label={label} 
                                  error={touched && error}
                                />}
    />

//     <Autocomplete
//     multiple
//     id="tags-standard"
//     options={options}
//     onBlur={() => formikProps.setFieldTouched(field.name) }
//     loading={true}
//     getOptionLabel={(option) => option.label}
//     onChange={ (e,v) => formikProps.setFieldValue(field.name, v) }
//     value={selectedValue ? selectedValue : ''}
//     renderInput={(params) => (
//       <TextField
//         {...params}
//         variant="standard"
//         label={'Label'}
//         placeholder={'Label'}
//       />
//     )}
//   />

        // <Autocomplete
        //     multiple
        //     onBlur={() => formikProps.setFieldTouched(field.name) }
        //     getOptionLabel={(option) => option.title}
        //     loading={true}
        //     loadingText={'Cargando...'}
        //     onChange={ (e,v) => formikProps.setFieldValue(field.name, v) } 
        //     value={selectedValue ? selectedValue : ''}
        //     renderOption={(props, option:any) => {
        //       return (
        //         <li {...props} key={option.value}>
        //           {option.label}
        //         </li>
        //       );
        //     }}
        //     disablePortal
        //     options={options}
        //     renderInput={(params) => <TextField 
        //                                  key={params.id}
        //                                  helperText={_renderHelperText()} 
        //                                 {...params} 
        //                                 label={label} 
        //                                 error={touched && error}
        //                               />}
        // />


      
            
  );
}

AutocompleteMultiple.defaultProps = {
  options: [],
  name: '',
  label: '',
  setValue: '',
  element: '',
  isdisabled: boolean,
  onChange: () => {},
};



export default AutocompleteMultiple;
